module.exports = __webpack_public_path__ + "img/1456779891.d508a49e.jpg";